<script>
import ApiService from "@services/api.service";

export default {
  name: "LeadsProgram",
  data() {
    return {
      title: "Leads Program",
      table: {
        sortBy: "description",
        fields: [
          { key: "description", sortable: true, label: "Program" },
          { key: "actions", class: "text-right" }
        ],
        data: [],
        filter: null
      },
      leadsProgram: {
        description: null,
        leadsTypeCode: null
      },
      showModal: false
    };
  },
  computed: {
    rowCount: function () {
      return this.table.data.length;
    },
    editMode: function () {
      return this.leadsProgram.code != null;
    }
  },
  created() {
    this.loadTable();
  },
  methods: {
    loadTable() {
      this.changeLoader(true);
      ApiService.get("LeadsProgram")
        .then(resp => {
          this.table.data = resp;
        })
        .finally(() => {
          this.changeLoader(false);
        });
    },
    openDetail(selectedRow) {
      if (selectedRow) {
        this.leadsProgram = { ...selectedRow };
      }
      this.showModal = true;
    },
    async save() {
      if (!this.editMode) {
        this.changeLoader(true);
        ApiService.post("LeadsProgram", this.leadsProgram)
          .then(resp => {
            this.showToast("success", "Create Successful");
            this.showModal = false;
            this.clearForm();
            this.loadTable();
          })
          .finally(() => {
            this.changeLoader(false);
          });
      } else {
        this.changeLoader(true);
        ApiService.put("LeadsProgram", this.leadsProgram)
          .then(resp => {
            this.showToast("success", "Edit Successful");
            this.showModal = false;
            this.clearForm();
            this.loadTable();
          })
          .finally(() => {
            this.changeLoader(false);
          });
      }
    },
    toggle(code) {
      this.changeLoader(true);
      let qs = {
        code: code
      };
      ApiService.patch("LeadsProgram", null, qs)
        .then(() => {
          this.showToast("success", "Toggle Successful");
          this.loadTable();
        })
        .catch(error => {
          this.showToast(error, "error");
        })
        .finally(() => {
          this.changeLoader(false);
        });
    },
    clearForm() {
      this.leadsProgram = {
        description: null,
        leadsTypeCode: null
      };
    }
  }
};
</script>

<template>
  <div>
    <b-card>
      <div id="mount-point"></div>
      <div class="d-flex mb-2">
        <b-btn variant="outline-primary" @click.stop="openDetail(null)">Create</b-btn>
        <div class="ml-auto">
          <b-input v-model="table.filter" placeholder="Filter" class="form-control text-right" />
        </div>
      </div>

      <b-table
        :items="table.data"
        :fields="table.fields"
        :sort-by.sync="table.sortBy"
        :filter="table.filter"
        no-provider-filtering
        empty-text="No data to show"
        striped
        outlined
        hover
        show-empty
        fixed
      >
        <template #cell(actions)="data">
          <div>
            <b-btn class="btn btn-sm btn-wide btn-warning mr-1" @click.stop="openDetail(data.item)">Edit</b-btn>
            <!-- <b-btn class="btn btn-sm btn-wide btn-danger" @click.stop="openDetail(data.item)">Delete</b-btn> -->
          </div>
        </template>
      </b-table>
    </b-card>

    <b-modal v-model="showModal" centered size="lg" hide-footer :backdrop="true" @hidden="clearForm">
      <div class="px-3 py-2">
        <b-row>
          <b-col class="text-center">
            <h2>{{ !editMode ? `Create New Program` : `Edit Program` }}</h2>
          </b-col>
        </b-row>
        <hr />
        <b-form @submit.stop.prevent="save">
          <b-row class="mb-2">
            <b-col md="4">
              <label>Program </label>
            </b-col>
            <b-col md="8">
              <b-input v-model="leadsProgram.description" class="form-control" />
              <small>Leads Program Description</small>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col>
              <b-btn block variant="danger" @click.stop="showModal = false">Cancel</b-btn>
            </b-col>
            <b-col>
              <b-btn block type="submit" variant="success">Save</b-btn>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-modal>
  </div>
</template>
